/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Brush_SizeInputs */

const en_landing_studio_brush_size = /** @type {(inputs: Landing_Studio_Brush_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brush size`)
};

const zh_landing_studio_brush_size = /** @type {(inputs: Landing_Studio_Brush_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`笔刷大小`)
};

/**
* | output |
* | --- |
* | "Brush size" |
*
* @param {Landing_Studio_Brush_SizeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_brush_size = /** @type {((inputs?: Landing_Studio_Brush_SizeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Brush_SizeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_brush_size(inputs)
	return zh_landing_studio_brush_size(inputs)
});
export { landing_studio_brush_size as "landing.studio.brush_size" }